import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Widgets */
import { PANELS } from "./Panel"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { VideoIcon } from "../../components/Icons"


/* Widget TableMenu — the panel buttons of a game page, the same ones for a live and an electron table */
class TableMenu extends Component {

    /* Keys Of The Menu — a superadmin additionally reaches the currencies and the settings of the table */
    getKeys = () => {

        /* Fields */
        const { keys, admin } = this.props

        /* Check Keys */
        const list = keys && Array.isArray(keys) ? keys : ["control", "message", "dealers"]

        /* SuperAdmin Panels */
        return utils.can(admin, "superadmin") ? [...list, "currencies", "settings"] : list
    }

    /* Items Of The Menu — the panels of the page itself stand first */
    getItems = () => {

        /* Fields */
        const { extra } = this.props

        /* Shared Panels */
        const items = this.getKeys().filter((key) => PANELS[key]).map((key) => ({ key, ...PANELS[key] }))

        /* Panels Of The Page */
        return extra && Array.isArray(extra) ? [...extra, ...items] : items
    }

    render = () => {

        /* Fields */
        const { open, video } = this.props

        return (
            <div className="tbl--menu">

                {this.getItems().map((item, index) =>
                    <div onClick={() => open(item.key)} className={`tbl--menu-item ${item.tone ? item.tone : ""}`} key={`${index}`}>
                        <div className="tbl--menu-icon">{item.icon(15)}</div>
                        <span>{item.text()}</span>
                    </div>
                )}

                {/* The archive belongs to the studio of the table, an electron game has none */}
                {video &&
                    <a target="_blank" href={video} rel="noreferrer" className="tbl--menu-item video">
                        <div className="tbl--menu-icon"><VideoIcon size={15} /></div>
                        <span>{t("game.videoArchive")}</span>
                    </a>
                }

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
    admin: state.admin,
})

export default connect(mapStateToProps)(TableMenu)
